import {Suspense, useEffect, useState} from 'react'
import {Route, Routes, Navigate ,useLocation, useNavigate  } from 'react-router-dom'
import TopBarProgress from 'react-topbar-progress-indicator'
import { useSelector } from "react-redux";
import { getCSSVariableValue } from '../../_template/assets/ts/utils/DomHelpers';
import MasterLayout from '../../_template/layout/MasterLayout';
import SystemUser from '../pages/admin/systemUser/SystemUser';
import LiveAssistant from '../pages/admin/liveAssistant/LiveAssistant';
import { AgentReport, CdrReport, MissedChat } from '../pages/admin/report'
import { BusinessSetup } from '../pages/admin/settings'
import {AgentAnalytics, BotAnalytics, ChatAnalytics} from '../pages/admin/analytics'
import Billing from '../pages/admin/billing/Billing';
import Agents from '../pages/admin/agents/Agents';
import Overview from '../pages/admin/guide/overview/Overview';
import Concepts from '../pages/admin/guide/concepts/Concepts';
import Channels from '../pages/admin/guide/channels/Channels';
import ManageVirtualAgent from '../pages/admin/manageAgent/ManageVirtualAgent';
import Deployments from '../pages/admin/guide/deployments/Deployments';
import BestPractices from '../pages/admin/guide/bestPractices/BestPractices';
import TruChatWidget from '../pages/admin/guide/truChatWidget/TruChatWidget';
import WidgetIntegration from '../pages/admin/guide/widgetIntegration/WidgetIntegration';

const SuspensedView = ({children}) => {
    const location = useLocation();
    const [progress, setProgress] = useState(true);
    TopBarProgress.config({
        barColors: {
            "0": '#f61616',
        },
        barThickness: 2,
        shadowBlur: 5,
    });

    useEffect(() => {
        setProgress(true);
        const timer = setTimeout(() => setProgress(false), 500);
        return () => clearTimeout(timer);
    }, [location]);

    return (
        <>
            {progress && <TopBarProgress />}
            <Suspense fallback={<TopBarProgress />}>{children}</Suspense>
        </>
    );
}
const PrivateRoutes = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const assignAllUrl = useSelector((state) => state.store_assign_url.menuUrl);
    useEffect(() => {
        if (assignAllUrl.length > 0) {
            let url_exists = assignAllUrl.some(item => location.pathname.startsWith(`/${item.menu_url}`));
            if (!url_exists) {
                navigate("/error");
                return;
            }
        }
    }, [location.pathname, navigate, assignAllUrl]);

    return (
        <Routes>
            <Route element={<MasterLayout />}>
                <Route index element={<Navigate to='/agents' />} />
                <Route path='/agents' element={
                    <SuspensedView>
                        <Agents />
                    </SuspensedView>
                }/>
                <Route path='/manage-virtual-agent' element={
                    <SuspensedView>
                        <ManageVirtualAgent />
                    </SuspensedView>
                }/>
                <Route path='/manage-virtual-agent/:param_bot_id' element={
                    <SuspensedView>
                        <ManageVirtualAgent />
                    </SuspensedView>
                }/>
                <Route path='/guide/overview' element={
                    <SuspensedView>
                        <Overview />
                    </SuspensedView>
                }/>
                <Route path='/guide/concepts' element={
                    <SuspensedView>
                        <Concepts />
                    </SuspensedView>
                }/>
                <Route path='/guide/channels' element={
                    <SuspensedView>
                        <Channels />
                    </SuspensedView>
                }/>
                <Route path='/guide/manage-virtual-agent/:param_bot_id' element={
                    <SuspensedView>
                        <ManageVirtualAgent />
                    </SuspensedView>
                }/>
                <Route path='/guide/deployments' element={
                    <SuspensedView>
                        <Deployments />
                    </SuspensedView>
                }/>
                <Route path='/guide/best-practices' element={
                    <SuspensedView>
                        <BestPractices />
                    </SuspensedView>
                }/> 
                <Route path='/guide/widget-integration' element={
                    <SuspensedView>
                        <WidgetIntegration />
                    </SuspensedView>
                }/> 
                <Route path='/truchat-widget' element={
                    <SuspensedView>
                        <TruChatWidget />
                    </SuspensedView>
                }/>
                <Route path='/report/cdr-report' element={
                    <SuspensedView>
                        <CdrReport />
                    </SuspensedView>
                }/>
                <Route path='/report/agent-report' element={
                    <SuspensedView>
                        <AgentReport />
                    </SuspensedView>
                }/>
                <Route path='/report/missed-chat' element={
                    <SuspensedView>
                        <MissedChat />
                    </SuspensedView>
                }/>
                <Route path='/system-user' element= {
                    <SuspensedView>
                        <SystemUser />
                    </SuspensedView>
                }/>
                <Route path='/billing' element={
                    <SuspensedView>
                        <Billing />
                    </SuspensedView>
                }/>
                <Route path='/live-assistant' element={
                    <SuspensedView>
                        <LiveAssistant />
                    </SuspensedView>
                }/>
                <Route path='/analytics/agent-analytics' element={
                    <SuspensedView>
                        <AgentAnalytics />
                    </SuspensedView>
                }/>
                <Route path='/analytics/bot-analytics' element={
                    <SuspensedView>
                        <BotAnalytics />
                    </SuspensedView>
                }/>
                <Route path='/analytics/chat-analytics' element={
                    <SuspensedView>
                        <ChatAnalytics />
                    </SuspensedView>
                }/>
                <Route path='/settings/business-setup' element={
                    <SuspensedView>
                        <BusinessSetup />
                    </SuspensedView>
                }/>
            </Route>
            <Route path='*' element={<Navigate to="/error" />} />
        </Routes>
    )
}

export default PrivateRoutes;